module.exports = {
    messages: {
        de: {
            footerNav: {
                disclaimer: "Alle Rechte vorbehalten",
                help: "Anleitung",
                imprint: "Impressum",
                infos: "Informationen",
                partners: "Kooperationspartner",
                privacy: "Datenschutz",
                terms: "Nutzungsbedingungen"
            }
        },
        en: {
            footerNav: {
                disclaimer: "All rights reserved",
                help: "Manual",
                imprint: "Imprint",
                infos: "Information",
                partners: "Partners",
                privacy: "Privacy policy",
                terms: "Terms and conditions"
            }
        },
        fr: {
            footerNav: {
                disclaimer: "Tous droits réservés",
                help: "Aide",
                imprint: "Mentions légales",
                infos: "Informations",
                partners: "Partenaires",
                privacy: "Données personnelles",
                terms: "Conditions générales"
            }
        }
    }
}
